export default __webpack_public_path__ + "static/media/sap.184c3e58.svg";